import classNames from 'classnames';

export default function Divider({ className = '' }) {
  return <div className={classNames('w-full my-4 border-t border-gray-200', className)} />;
}
